import * as devEnv from './environment.dev';

export const environment = {
  ...devEnv.environment,
  BASE_HREF: '/',
};
